const API_BASE_URL =
  "https://ly4pkjlbei.execute-api.us-east-2.amazonaws.com/stage"

export const GET_CHAPTERS = `${API_BASE_URL}/chapters`
export const GET_CHAPTER_DETAILS = `${API_BASE_URL}/chapter-details`
